var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 27V28H27.25V29.125H26.25V28H16V29.125H15V28H8V27H34ZM29.75 13C30.4404 13 31 13.5596 31 14.25V23.75C31 24.4404 30.4404 25 29.75 25H12.25C11.5596 25 11 24.4404 11 23.75V14.25C11 13.5596 11.5596 13 12.25 13H29.75ZM29.75 14H12.25C12.1119 14 12 14.1119 12 14.25V23.75C12 23.8881 12.1119 24 12.25 24H29.75C29.8881 24 30 23.8881 30 23.75V14.25C30 14.1119 29.8881 14 29.75 14ZM23 21.05V22.05H13V21.05H23ZM24.875 16C25.9105 16 26.75 16.8395 26.75 17.875C26.75 18.9105 25.9105 19.75 24.875 19.75C23.8395 19.75 23 18.9105 23 17.875C23 16.8395 23.8395 16 24.875 16ZM19.25 18.55V19.55H13V18.55H19.25ZM24.875 17C24.3918 17 24 17.3918 24 17.875C24 18.3582 24.3918 18.75 24.875 18.75C25.3582 18.75 25.75 18.3582 25.75 17.875C25.75 17.3918 25.3582 17 24.875 17ZM19.25 16.05V17.05H13V16.05H19.25Z",
    fill: "#754FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTraining);
export default __webpack_public_path__ + "static/media/job-training.c1bf2f0d26c87f9b3f8ade2f097d94f2.svg";
export { ForwardRef as ReactComponent };